import React, { FC } from "react";
import { BuildJobData } from "../../models/types";
import { Button } from "react-bootstrap";
import styles from "./ToggleButtonComponent.module.scss";
import cx from "classnames";

interface ToggleButtonProps {
    jobData: BuildJobData;
    hasDuplicate: boolean;
    isDuplicate: boolean;
    onToggle?: (newState: BuildJobData) => void;
}

export const ToggleButtonComponent: FC<ToggleButtonProps> = ({
    jobData,
    hasDuplicate,
    isDuplicate,
    onToggle
}) => {
    const onClick = () => {
        if (onToggle) {
            const newState = { ...jobData, include: !jobData.include };
            onToggle(newState);
        }
    };

    return (
        <Button
            value={jobData.name}
            disabled={hasDuplicate}
            className={cx(styles.resultButton, {
                "btn-success": !hasDuplicate && jobData.include,
                "btn-secondary": hasDuplicate || !jobData.include,
                "btn-danger": isDuplicate
            })}
            onClick={() => onClick()}
        >
            {jobData.name}
        </Button>
    );
};
